/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key, react/prop-types */
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import TermosDeUso from '../components/TermosDeUso';
import LGPD from '../components/LGPD';
import PadariaDetalhes from '../components/PadariaDetalhes';
import ModalVotacao from '../components/ModalVotacao';
import Regulamento from '../components/Regulamento';

import Hero from '../components/shared/Hero';
import Patrocinadores from '../components/shared/Patrocinadores';
import Categorias from '../components/shared/Categorias';
import PadariasFase2 from '../components/shared/PadariasFase2';
import ResultadosFase3 from '../components/shared/ResultadosFase3';
import BannerFixo from '../components/shared/BannerFixo';
import BannersRotativos from '../components/shared/BannersRotativos';
import Footer from '../components/shared/Footer';
import premiacoesSP from '../data/premiacoes/sao-paulo.json';
import premiacoesBH from '../data/premiacoes/belo-horizonte.json';
import { setApiCity } from '../plugins/axios';

import { useGlobal } from '../contexts/global';
import { buscaPadarias } from '../services/Votacao';

import {
  getFase,
  isPreConcurso,
  exibeBotaoVotar,
  exibeCategoriasFase1,
  exibePadariasFase2,
  isFase1Encerrada,
  isFase2Encerrada,
  isFase2Ativa,
  FASES
} from '../utils/fase';

import iconFirst from '../assets/images/icon_first.png';
import iconStep1 from '../assets/images/icon_step_1.png';
import iconStep2 from '../assets/images/icon_step_2.png';
import iconStepAward from '../assets/images/icon_step_award.png';
import iconCalendar from '../assets/images/icon_calendar.png';
import iconCheck from '../assets/images/icon_check.png';
import iconTrigo from '../assets/images/icon_trigo.png';
import bgContest from '../assets/images/bg_contest.png';
import bgStep from '../assets/images/bg_step.png';

import { getImagem } from '../utils/imagens';

import '../assets/scss/Home.scss';

/* eslint-disable react/prop-types */
const CidadePage = ({ cidade }) => {
  const fase = getFase(cidade);
  const location = useLocation();
  const history = useHistory();
  const [padarias, setPadarias] = useState({});

  const {
    success,
    setSuccess,
    error,
    setError,
    showModalVotacao,
    showRegulamento,
    setZonaAtual,
    setCenter,
    setActiveTabKey
  } = useGlobal();

  const scroll = () => {
    const btVotar = document.getElementById('bt-votar');
    if (btVotar) btVotar.style.display = 'none';
    const sectionVotacao = document.getElementById('section-votacao');
    if (sectionVotacao) {
      sectionVotacao.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const goTo = (path, saveScroll = false) => {
    if (!path) return;
    if (saveScroll) {
      sessionStorage.setItem('lastScroll', window.scrollY);
    }
    history.push(path);
  };

  const handleCategoriaClick = (slug, fase1Ativa) => {
    if (fase1Ativa) {
      goTo(`/votacao/${slug}`, true);
    }
  };

  useEffect(() => {
    if (cidade.slug) {
      setApiCity(cidade.slug);
    }
    if (cidade.coordenadas) {
      setCenter(cidade.coordenadas);
    }
  }, [cidade]);

  useEffect(() => {
    if (!location.pathname.includes('/padaria/')) {
      sessionStorage.setItem('cidadeAtivaPage', location.pathname);
    }
  }, [location.pathname]);

  useEffect(() => {
    let unmounted = false;
    if (cidade.abas) {
      const primeiraZona = Object.values(cidade.abas)[0];
      setZonaAtual(primeiraZona);
    }

    const loadPadarias = async () => {
      const resp = await buscaPadarias();
      if (!unmounted) setPadarias(resp);
    };

    loadPadarias();

    if (success) {
      Swal.fire({
        timer: 2500,
        icon: 'success',
        showConfirmButton: false,
        html: '<p class="in-home-modal-title">Seu voto foi confirmado com sucesso. Obrigado!</p>',
        didClose: () => {
          setSuccess(false);
          setError(false);
          history.push(cidade.pagina);
        }
      });
    }

    if (error) {
      const errorText =
        typeof error === 'string' && error.trim() !== ''
          ? error
          : 'Usuário já votou nessa categoria!';

      Swal.fire({
        timer: 3500,
        icon: 'error',
        showConfirmButton: false,
        text: errorText,
        didClose: () => {
          setSuccess(false);
          setError(false);
        }
      });
    }

    return () => {
      unmounted = true;
    };
  }, []);

  useEffect(() => {
    const proximaZonaKey = localStorage.getItem('proxima_zona');
    if (proximaZonaKey) {
      if (setActiveTabKey) {
        setActiveTabKey(proximaZonaKey);
      }

      setTimeout(() => {
        const padariasElement =
          document.getElementById('padarias') ||
          document.getElementById('section-votacao');
        if (padariasElement) {
          const y =
            padariasElement.getBoundingClientRect().top +
            window.pageYOffset -
            20;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }

        const normKey = (proximaZonaKey || '')
          .toLowerCase()
          .replace(/[-_\s]+/g, '');
        const tabs = document.querySelectorAll('[data-tab-key]');
        tabs.forEach((tabEl) => {
          const k = (tabEl.getAttribute('data-tab-key') || '')
            .toLowerCase()
            .replace(/[-_\s]+/g, '');
          if (k === normKey) {
            tabEl.click();
          }
        });
      }, 500);

      localStorage.removeItem('proxima_zona');
    }
  }, [setActiveTabKey]);

  const fasePrimeiro = fase.charAt(0);
  const faseAtual = getFase(cidade);
  const mostrarBotaoVotar = exibeBotaoVotar(cidade);
  const mostrarCategorias = exibeCategoriasFase1(cidade);
  const mostrarPadarias = exibePadariasFase2(cidade);
  const isFase3 = faseAtual === FASES.FASE_3;

  const premiacaoCidade =
    cidade.slug === 'belo-horizonte' ? premiacoesBH : premiacoesSP;
  const anoMaisRecente =
    premiacaoCidade?.anosDisponiveis?.[0] ||
    String(premiacaoCidade?.ano || 2026);
  const dadosPremiacaoMaisRecente = premiacaoCidade?.historico?.[
    anoMaisRecente
  ] || {
    horsConcours: premiacaoCidade?.horsConcours || [],
    premiacao: premiacaoCidade?.premiacao || []
  };

  const temBannerPosicao2 = Boolean(
    cidade.banners?.some(
      (b) => b.posicao === 2 && getImagem(b.video || b.imagem)
    )
  );
  const mostrarSecaoVotacao =
    !isFase3 ||
    mostrarCategorias ||
    mostrarPadarias ||
    temBannerPosicao2 ||
    dadosPremiacaoMaisRecente.horsConcours.length > 0 ||
    (dadosPremiacaoMaisRecente.premiacao?.length || 0) > 0 ||
    (dadosPremiacaoMaisRecente.regioes?.length || 0) > 0;

  return (
    <>
      {/* Modais */}
      {location.pathname.endsWith('/termos-de-uso') && (
        <TermosDeUso cidade={cidade} />
      )}
      {location.pathname.endsWith('/lgpd') && <LGPD cidade={cidade} />}
      {(location.pathname.split('/')[1] === 'padaria' ||
        location.pathname.includes('/padaria/')) && (
        <PadariaDetalhes cidade={cidade} />
      )}
      {showModalVotacao && <ModalVotacao cidade={cidade} />}
      {showRegulamento && <Regulamento cidade={cidade} />}

      <section>
        {/* Botão flutuante "Vote agora!" */}
        {mostrarBotaoVotar && (
          <section className="in-votenow" id="bt-votar">
            <span onClick={scroll}>Vote agora!</span>
          </section>
        )}

        {/* Hero */}
        <Hero
          cidade={cidade}
          mostrarBotaoVotar={mostrarBotaoVotar}
          onVoteClick={scroll}
        />

        {!isPreConcurso(cidade) && (
          <>
            {/* Seção: A Premiação — exibida apenas antes da Fase 3 */}
            {!isFase3 && (
              <section className="in-contest">
                <div className="in-contest-bg">
                  <img src={bgContest} alt="Background Contest" />
                </div>
                <div className="in-contest-line">
                  <hr />
                </div>

                {/* Banner Fixo 1 */}
                <BannerFixo posicao={1} banners={cidade.banners} />

                {/* Cards etapas */}
                <div className="in-contest-ctn">
                  <div className="in-contest-ctn-grid">
                    <div className="in-contest-ctn-grid-sup">
                      <img src={iconFirst} alt="Premiação" />
                      <p>A Premiação</p>
                      <p>
                        Por meio do voto popular e de um júri composto por
                        <br />
                        especialistas em gastronomia e por pessoas que conhecem
                        a
                        <br />
                        cidade a fundo, vamos eleger as melhores padarias de
                        <br />
                        {cidade.nome}, em diversas categorias
                      </p>
                    </div>
                    <div className="in-contest-ctn-grid-sub">
                      {cidade.fases &&
                        cidade.fases.map((etapa) => {
                          if (etapa.numero === 3) {
                            return (
                              <div
                                key={etapa.numero}
                                className="in-contest-ctn-grid-sub-step"
                              >
                                <div className="in-contest-ctn-grid-sub-step-image">
                                  <hr />
                                  <img src={iconStepAward} alt="Premiação" />
                                </div>
                                <div className="in-contest-ctn-grid-sub-step-award">
                                  <p>{etapa.titulo}</p>
                                  <p
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                      __html: etapa.descricao
                                    }}
                                  />
                                  {etapa.destaque && <p>{etapa.destaque}</p>}
                                  <button type="button">
                                    <img src={iconCalendar} alt="Data" />
                                    <span>{etapa.data}</span>
                                  </button>
                                </div>
                              </div>
                            );
                          }

                          const icone =
                            etapa.numero === 1 ? iconStep1 : iconStep2;
                          const encerrada =
                            (etapa.numero === 1 && isFase1Encerrada(cidade)) ||
                            (etapa.numero === 2 && isFase2Encerrada(cidade));

                          return (
                            <div
                              key={etapa.numero}
                              className="in-contest-ctn-grid-sub-step"
                            >
                              {encerrada && (
                                <div className="in-contest-ctn-grid-sub-step-container-strip">
                                  <div className="in-contest-ctn-grid-sub-step-strip">
                                    <h3>Fase encerrada!</h3>
                                  </div>
                                </div>
                              )}
                              <div className="in-contest-ctn-grid-sub-step-image">
                                <hr />
                                <img src={icone} alt={`Fase ${etapa.numero}`} />
                              </div>
                              <div className="in-contest-ctn-grid-sub-step-list">
                                {etapa.numero === 2 ? (
                                  <p>
                                    {etapa.titulo}
                                    <br />
                                    <span
                                      // eslint-disable-next-line react/no-danger
                                      dangerouslySetInnerHTML={{
                                        __html: etapa.descricao
                                      }}
                                    />
                                  </p>
                                ) : (
                                  <>
                                    <p>{etapa.titulo}</p>
                                    {etapa.descricao && (
                                      <p>
                                        <span
                                          // eslint-disable-next-line react/no-danger
                                          dangerouslySetInnerHTML={{
                                            __html: etapa.descricao
                                          }}
                                        />
                                      </p>
                                    )}
                                  </>
                                )}
                                <ul>
                                  {etapa.itens &&
                                    etapa.itens.map((item, i) => (
                                      <li key={i}>
                                        <img src={iconCheck} alt="" />
                                        <p>{item}</p>
                                      </li>
                                    ))}
                                </ul>
                                <button type="button">
                                  <img src={iconCalendar} alt="Data" />
                                  <span>{etapa.periodo}</span>
                                </button>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </section>
            )}

            {/* Seção: Votação */}
            {mostrarSecaoVotacao && (
              <section className={`in-step in-step--${cidade.slug}`}>
                <div className="in-step-bg">
                  <img src={bgStep} alt="Background Step" />
                </div>
                <div className="in-step-ctn">
                  <div className="in-step-ctn-grid">
                    <div className="in-step-ctn-grid-ctt" id="section-votacao">
                      {/* Banner Fixo 2 */}
                      <BannerFixo posicao={2} banners={cidade.banners} />

                      <div className="in-step-ctn-grid-ctt-title">
                        <div className="in-step-ctn-grid-ctt-title-main">
                          <img src={iconTrigo} alt="Trigo" />
                          <p>
                            {isFase3 ? 'Resultado' : `Fase ${fasePrimeiro}:`}
                          </p>
                        </div>
                        <div className="in-step-ctn-grid-ctt-title-info">
                          <p />
                          {(exibeCategoriasFase1(cidade) ||
                            isFase2Ativa(cidade)) &&
                            cidade.instrucoesVotacao && (
                              <p>
                                <strong>
                                  {cidade.instrucoesVotacao.titulo}
                                </strong>
                                <br />
                                {cidade.instrucoesVotacao.descricao}
                                <br />
                                {isFase2Ativa(cidade) &&
                                  cidade.instrucoesVotacao.alerta && (
                                    <strong>
                                      {cidade.instrucoesVotacao.alerta}
                                    </strong>
                                  )}
                                {cidade.instrucoesVotacao.alertaConteudo}
                              </p>
                            )}
                        </div>
                      </div>

                      {/* Cards de categorias — Fase 1 */}
                      {mostrarCategorias && (
                        <Categorias
                          cidade={cidade}
                          categorias={cidade.categorias}
                          onCategoriaClick={handleCategoriaClick}
                        />
                      )}

                      {/* Tabs de padarias — Fase 2 */}
                      {mostrarPadarias && (
                        <PadariasFase2
                          padarias={padarias}
                          abas={cidade.abas || {}}
                          cidade={cidade}
                        />
                      )}

                      {/* Resultados da Fase 3 — Vencedores */}
                      {isFase3 && (
                        <ResultadosFase3
                          dados={dadosPremiacaoMaisRecente}
                          cidade={cidade}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </section>
            )}

            {/* Seção: O que é? */}
            <section className="in-whatis">
              <div className="in-whatis-line1">
                <hr />
              </div>

              {/* Banner Fixo 3 */}
              <BannerFixo posicao={3} banners={cidade.banners} />

              <div className="in-whatis-ctn">
                <div className="in-whatis-ctn-grid">
                  <div
                    className={`in-whatis-ctn-grid-lf ${
                      cidade.oQueE.imagem ? 'in-whatis-ctn-grid-lf--image' : ''
                    }`}
                  >
                    {cidade.oQueE.imagem ? (
                      <img
                        src={getImagem(cidade.oQueE.imagem)}
                        alt={cidade.oQueE.titulo}
                        className="in-whatis-ctn-grid-lf-img"
                      />
                    ) : (
                      <>
                        <div className="in-whatis-ctn-grid-lf-title">
                          <p>{cidade.oQueE.fraseCidade}</p>
                          <p>
                            <span>
                              {cidade.oQueE.fraseDestaque?.split('é a ')[0]}é a{' '}
                            </span>
                            {cidade.oQueE.fraseDestaque?.split('é a ')[1]}
                          </p>
                        </div>
                        <div className="in-whatis-ctn-grid-lf-map">
                          {cidade.oQueE.estatisticas &&
                            cidade.oQueE.estatisticas.map((stat, i) => {
                              const iconeSrc = getImagem(stat.icone);
                              return (
                                <div
                                  key={i}
                                  className="in-whatis-ctn-grid-lf-map-item"
                                >
                                  {iconeSrc && (
                                    <img src={iconeSrc} alt={stat.label} />
                                  )}
                                  <div>
                                    <p>{stat.valor}</p>
                                    <p>{stat.label}</p>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        {cidade.oQueE.fonte && (
                          <div className="in-whatis-ctn-grid-lf-font">
                            <p>{cidade.oQueE.fonte}</p>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="in-whatis-ctn-grid-rt">
                    {cidade.oQueE.icon && (
                      <img
                        src={getImagem(cidade.oQueE.icon)}
                        alt={cidade.oQueE.titulo}
                      />
                    )}
                    <div className="in-whatis-ctn-grid-rt-info">
                      <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                          __html: cidade.oQueE.titulo.replace(
                            /Padocaria/i,
                            '<br /> Padocaria'
                          )
                        }}
                      />
                      <p>{cidade.oQueE.descricao}</p>
                      <div>
                        <p>Objetivo</p>
                        <p>{cidade.oQueE.objetivo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="in-whatis-line2">
                <hr />
              </div>
            </section>

            {/* Banner Fixo 1 — exibido aqui na Fase 3 */}
            {isFase3 && (
              <BannerFixo posicao={1} banners={cidade.banners} standalone />
            )}

            {/* Seção: Edições Anteriores */}
            {cidade.slug !== 'belo-horizonte' && (
              <section className="in-previous-editions">
                <div className="in-previous-editions-bg">
                  <img
                    src={getImagem('bg-outras-edicoes.webp')}
                    alt="Background"
                  />
                </div>
                <div className="in-previous-editions-ctn">
                  <div className="in-previous-editions-ctn-grid">
                    <div className="in-previous-editions-ctn-grid-logo">
                      <img
                        src={getImagem('categorias/trofeu-padocaria.webp')}
                        alt="Troféu"
                      />
                    </div>
                    <div className="in-previous-editions-ctn-grid-info">
                      <h2>
                        Quer conhecer as padarias campeãs de todas as edições do
                        concurso?
                      </h2>
                      <div className="in-init-ctn-grid-info-votenow">
                        <span
                          onClick={() => goTo(cidade.urlPremiacoes)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') goTo(cidade.urlPremiacoes);
                          }}
                        >
                          Clique aqui e confira
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {/* Feed Instagram */}
            {cidade.footer.instagramFeedUrl && (
              <section className="align-feed-instagram">
                {/* Banner Fixo 4 */}
                <BannerFixo posicao={4} banners={cidade.banners} />

                <iframe
                  className="in-feed-instagram"
                  src={cidade.footer.instagramFeedUrl}
                  title="Feed Instagram"
                />
              </section>
            )}

            {/* Rodapé de redes sociais */}
            {cidade.footer.instagramUrl && (
              <section className="in-iframe">
                {/* Banner Fixo 5 */}
                <BannerFixo posicao={5} banners={cidade.banners} />

                <div className="in-iframe-grid">
                  <div className="in-iframe-grid-sup">
                    <img src={getImagem('icon_chat.png')} alt="Chat" />
                    <a
                      href={cidade.footer.instagramUrl}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {cidade.footer.instagram}
                    </a>
                  </div>
                </div>
              </section>
            )}

            {/* Patrocinadores no Rodapé */}
            <section className="in-partiners">
              <div className="in-partiners-ctn">
                <div className="in-partiners-ctn-grid">
                  {cidade.footer.logoSmall && (
                    <div className="in-partiners-ctn-grid-logo">
                      <img
                        src={getImagem(cidade.footer.logoSmall)}
                        alt={cidade.footer.logoAlt || 'Logo'}
                      />
                    </div>
                  )}

                  {/* Banners Rotativos */}
                  {cidade.bannersRotativos &&
                    cidade.bannersRotativos.length > 0 && (
                      <BannersRotativos banners={cidade.bannersRotativos} />
                    )}

                  <Patrocinadores
                    patrocinadores={cidade.patrocinadores}
                    className={`regua-patrocinio--${cidade.slug}`}
                  />
                </div>
              </div>
            </section>
          </>
        )}

        {/* Footer */}
        <Footer cidade={cidade} />
      </section>
    </>
  );
};

export default CidadePage;
